<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <section class="full hr mb0">
      <div class="sortArea filter mb0">
        <div class="lcont">
          <span class="txt">
            총
            <em>9,999</em>
            개
          </span>
        </div>
        <div class="rcont">
          <select class="btnTxt_sort sel" title="상품정렬 선택">
            <option value="" selected="selected">전체</option>
            <option value="">렌탈</option>
            <option value="">구매</option>
            <option value="">정기배송</option>
          </select>
          <select class="btnTxt_sort sel" title="정렬기준 선택">
            <option value="" selected="selected">유효기간순</option>
            <option value="">최근발급순</option>
          </select>
        </div>
      </div>
    </section>

    <ul class="prdList vertical">
      <li v-for="(value, key) in categoryPrdList" :key="key">
        <div class="imgArea">
          <a href="#link" class="imgWrap">
            <span class="img">
              <!-- <img :src="IMG_DOMAIN + value.detailThumbnail1" :alt="value.displayName" /> -->
            </span>
          </a>
          <div class="prdUtil">
            <a href="#link" class="btn zzim"><span>999</span></a>
            <a href="#link" class="btn compare">상품비교하기</a>
          </div>
        </div>
        <div class="infoArea">
          <p class="prdCode">{{ value.productCode }}</p>
          <div class="ratingWrap">
            <span class="starRating">
              <span style="width:70%"></span>
            </span>
            <span class="point">3.5</span>
          </div>
          <a href="javascript:;" class="prdTit">
            <span>{{ value.displayName }}</span>
          </a>

          <div class="prdPrice">
            <div class="row">
              <span class="info">렌탈</span>
              <div class="val">
                <span class="price">
                  월
                  <span class="money">{{ value.rentalAmount }}</span>
                  원
                </span>
              </div>
            </div>
            <div class="row benefit">
              <span class="info">제휴카드혜택</span>
              <div class="val">
                <span class="price">
                  월
                  <span class="money">{{ value.cardDCrentalAmount }}</span>
                  원
                </span>
              </div>
            </div>
            <div class="row">
              <span class="info">구매</span>
              <div class="val">
                <span class="price">
                  <span class="money">112,900</span>
                  원
                </span>
              </div>
            </div>
          </div>
        </div>
      </li>
      <infinite-loading spinner="circles" @infinite="infiniteHandler" />
    </ul>
  </div>

  <!-- wrapper(e) -->
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import ApiService from '@/common/api.service';

export default {
  name: 'scrollPageSample',
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      api_url: '',
      pageIdx: 0,
      categoryPrdList: [],
      IMG_DOMAIN: '',
      content: [],
    };
  },
  mounted() {
    this.api_url = process.env.VUE_APP_API_URL;
    this.IMG_DOMAIN = process.env.VUE_APP_IMG_URL;
  },
  methods: {
    infiniteHandler($state) {
      console.log('page:' + this.pageIdx); // page No
      ApiService.service('GET', '/common/category/1/sub/1', {
        // 테스트라 고정 url로 호출
        params: '',
      })
        .then(({ data }) => {
          console.log(data);
          for (let value of data.result.productList.content) {
            this.categoryPrdList.push(value);
          }
          this.pageIdx += 1; // page NO + 1
          $state.loaded();
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
  },
};
</script>
